import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view")
  const _component_van_floating_bubble = _resolveComponent("van-floating-bubble")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_router_view),
    ($data.showBubble && _ctx.$route.meta.showBubble)
      ? (_openBlock(), _createBlock(_component_van_floating_bubble, {
          key: 0,
          offset: $data.bubbleOffset,
          axis: "xy",
          icon: "chat",
          magnetic: "x",
          onClick: $options.zhiNengKeFu,
          onOffsetChange: $options.onOffsetChange
        }, null, 8, ["offset", "onClick", "onOffsetChange"]))
      : _createCommentVNode("", true)
  ]))
}